import { parseJwt } from './parseJwt';

export const isTokenExpired = (token) => {
  if (!token) return true;

  const THOUSAND = 1000;
  const currentTime = Date.now() / THOUSAND;

  return currentTime > parseJwt(token).exp;
};
